import { graphql } from 'gatsby';
import React, { useEffect, useMemo, useState } from 'react';
import Button from '../../components/Button/Button';
import Image from '../../components/Image/Image';
import PrismicLink from '../../components/PrismicLink/PrismicLink';
import { isLightColor } from '../../utils/isLightColor';

function CtaSlots({
    bg = null,
    CTA: { document: { data: { body = [] } = {} } = {} } = {},
}) {
    const isDarkBackground = useMemo(() => bg && !isLightColor(bg), [bg]);

    return body?.flatMap((cta) => {
        switch (cta.items[0]?.__typename) {
            case 'PrismicCtaDataBodyButtonsItem':
                return cta.items.map(
                    (
                        {
                            text,
                            link,
                            variant,
                            colorScheme,
                            tracking_event,
                            size,
                        },
                        i
                    ) => (
                        <PrismicLink link={link} key={i} tabIndex={-1}>
                            <Button
                                variant={variant}
                                minWidth="160px"
                                fullWidth
                                isLight={isDarkBackground}
                                trackingEvent={tracking_event}
                                size={size}
                            >
                                {text}
                            </Button>
                        </PrismicLink>
                    )
                );
            case 'PrismicCtaDataBodyIconButtonItem':
                return cta.items.map(({ icon, link, tracking_event }, i) => (
                    // <PrismicLink link={link} key={i} tabIndex={-1}>
                    <Button
                        variant="tertiary"
                        size="md"
                        width="48px"
                        trackingEvent={tracking_event}
                    >
                        <Image img={icon} style={{ width: '32px' }} />
                    </Button>
                    // </PrismicLink>
                ));
            // case 'PrismicCtaDataBodyArrowLink':
            //     return (
            //         <PrismicLink link={cta.primary.link}>
            //             <Head3 accent>
            //                 <ArrowLink>{cta.primary.text}</ArrowLink>
            //             </Head3>
            //         </PrismicLink>
            //     );
            default:
                return null;
        }
    });
}

export default CtaSlots;

export const _ = graphql`
    fragment CTA_FRAGMENT on PrismicCta {
        data {
            body {
                __typename
                ... on PrismicCtaDataBodyButtons {
                    items {
                        __typename
                        variant
                        size
                        text
                        link {
                            ...PRISMIC_LINK_FRAGMENT
                        }
                    }
                }
                # ... on PrismicCtaDataBodySignupEmailInput {
                #     primary {
                #         placeholder
                #         submit_text
                #         secondary
                #     }
                # }
                # ... on PrismicCtaDataBodyArrowLink {
                #     primary {
                #         text
                #         link {
                #             ...PRISMIC_LINK_FRAGMENT
                #         }
                #     }
                # }
            }
        }
    }
`;
